import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';

const url = window.location.origin

const oidcConfig ={
  authority: process.env.REACT_APP_AUTHORITY || 'https://whodis.unify.fun',
  client_id: process.env.REACT_APP_CLIENT_ID || 'tickets-dev',
  redirect_uri: url,
  silent_redirect_uri: `${url}/oidc/renew`,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  response_type: 'code',
  post_logout_redirect_uri: url,
  scope: `openid profile ${process.env.REACT_APP_SCOPE ||'tickets-api-dev'}`,
  loadUserInfo: true,
}

const signinCallback = () => {
  window.history.replaceState(
    {},
    document.title,
    window.location.pathname
  )
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider 
      {...oidcConfig}
      onSigninCallback={signinCallback}
    >
      <App />
    </AuthProvider>
  </React.StrictMode>
);

